// Shared constants for MIFO application

export const API_ENDPOINTS = {
  AUTH: '/api/auth',
  COURSES: '/api/courses',
  ORDERS: '/api/orders',
  CUSTOMERS: '/api/customers',
  INVOICES: '/api/invoices',
  MOLLIE: '/api/mollie'
}

export const FORM_FIELDS = {
  ANREDE_OPTIONS: [
    { value: 'herr', label: 'Herr' },
    { value: 'frau', label: 'Frau' },
    { value: 'keine', label: 'Keine Angabe' }
  ],
  
  FACHRICHTUNG_OPTIONS: [
    { value: 'allgemeinmedizin', label: 'Allgemeinmedizin (Hausarzt)' },
    { value: 'anaesthesiologie', label: 'Anästhesiologie' },
    { value: 'anatomie', label: 'Anatomie' },
    { value: 'arbeitsmedizin', label: 'Arbeitsmedizin (Betriebsmedizin)' },
    { value: 'chirurgie', label: 'Chirurgie' },
    { value: 'herzchirurgie', label: 'Herzchirurgie' },
    { value: 'innere_medizin', label: 'Innere Medizin' },
    { value: 'innere_medizin_angiologie', label: 'Innere Medizin und Angiologie' },
    { value: 'innere_medizin_endokrinologie', label: 'Innere Medizin und Endokrinologie und Diabetologie' },
    { value: 'innere_medizin_gastroenterologie', label: 'Innere Medizin und Gastroenterologie' },
    { value: 'innere_medizin_haematologie', label: 'Innere Medizin und Hämatologie und Onkologie' },
    { value: 'innere_medizin_kardiologie', label: 'Innere Medizin und Kardiologie' },
    { value: 'innere_medizin_nephrologie', label: 'Innere Medizin und Nephrologie' },
    { value: 'innere_medizin_pneumologie', label: 'Innere Medizin und Pneumologie' },
    { value: 'innere_medizin_rheumatologie', label: 'Innere Medizin und Rheumatologie' },
    { value: 'kinder_jugendmedizin', label: 'Kinder- und Jugendmedizin' },
    { value: 'mikrobiologie', label: 'Mikrobiologie, Virologie und Infektionsepidemiologie' },
    { value: 'neurochirurgie', label: 'Neurochirurgie' },
    { value: 'neurologie', label: 'Neurologie' },
    { value: 'nuklearmedizin', label: 'Nuklearmedizin' },
    { value: 'oeffentliches_gesundheitswesen', label: 'Öffentliches Gesundheitswesen' },
    { value: 'pathologie', label: 'Pathologie' },
    { value: 'pharmakologie', label: 'Pharmakologie' },
    { value: 'physikalische_rehabilitative_medizin', label: 'Physikalische und Rehabilitative Medizin' },
    { value: 'physiologie', label: 'Physiologie' },
    { value: 'radiologie', label: 'Radiologie' },
    { value: 'rechtsmedizin', label: 'Rechtsmedizin' },
    { value: 'sonstige', label: 'Sonstige' }
  ],
  
  SCHALLER_OPTIONS: [
    { value: 'rechtsschaller', label: 'Rechtsschaller (Schallkopf in der rechten Hand)' },
    { value: 'linksschaller', label: 'Linksschaller (Schallkopf in der linken Hand)' },
    { value: 'noch_nicht_festgelegt', label: 'Noch nicht festgelegt' }
  ]
}

export const UI_CONSTANTS = {
  BRAND_COLORS: {
    PRIMARY: '#263D42',
    ACCENT: '#A31A4A',
    HIGHLIGHT: '#227C9D'
  },
  
  FONTS: {
    BODY: 'Open Sans',
    HEADING: 'Poppins'
  }
} 

// Comprehensive country list with DACH countries at the top (used by forms)
export const COUNTRIES = [
  // DACH countries at the top
  { code: 'DE', name: 'Deutschland' },
  { code: 'AT', name: 'Österreich' },
  { code: 'CH', name: 'Schweiz' },
  // Separator
  { code: '', name: '──────────' },
  // All other countries
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albanien' },
  { code: 'DZ', name: 'Algerien' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua und Barbuda' },
  { code: 'AR', name: 'Argentinien' },
  { code: 'AM', name: 'Armenien' },
  { code: 'AU', name: 'Australien' },
  { code: 'AZ', name: 'Aserbaidschan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesch' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgien' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivien' },
  { code: 'BA', name: 'Bosnien und Herzegowina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brasilien' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BG', name: 'Bulgarien' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'KH', name: 'Kambodscha' },
  { code: 'CM', name: 'Kamerun' },
  { code: 'CA', name: 'Kanada' },
  { code: 'CV', name: 'Kap Verde' },
  { code: 'CF', name: 'Zentralafrikanische Republik' },
  { code: 'TD', name: 'Tschad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Kolumbien' },
  { code: 'KM', name: 'Komoren' },
  { code: 'CG', name: 'Kongo' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'HR', name: 'Kroatien' },
  { code: 'CU', name: 'Kuba' },
  { code: 'CY', name: 'Zypern' },
  { code: 'CZ', name: 'Tschechische Republik' },
  { code: 'CD', name: 'Demokratische Republik Kongo' },
  { code: 'DK', name: 'Dänemark' },
  { code: 'DJ', name: 'Dschibuti' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominikanische Republik' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Ägypten' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GQ', name: 'Äquatorialguinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estland' },
  { code: 'ET', name: 'Äthiopien' },
  { code: 'FJ', name: 'Fidschi' },
  { code: 'FI', name: 'Finnland' },
  { code: 'FR', name: 'Frankreich' },
  { code: 'GA', name: 'Gabun' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GE', name: 'Georgien' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GR', name: 'Griechenland' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HU', name: 'Ungarn' },
  { code: 'IS', name: 'Island' },
  { code: 'IN', name: 'Indien' },
  { code: 'ID', name: 'Indonesien' },
  { code: 'IR', name: 'Iran' },
  { code: 'IQ', name: 'Irak' },
  { code: 'IE', name: 'Irland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italien' },
  { code: 'CI', name: 'Elfenbeinküste' },
  { code: 'JM', name: 'Jamaika' },
  { code: 'JP', name: 'Japan' },
  { code: 'JO', name: 'Jordanien' },
  { code: 'KZ', name: 'Kasachstan' },
  { code: 'KE', name: 'Kenia' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KP', name: 'Nordkorea' },
  { code: 'KR', name: 'Südkorea' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KG', name: 'Kirgisistan' },
  { code: 'LA', name: 'Laos' },
  { code: 'LV', name: 'Lettland' },
  { code: 'LB', name: 'Libanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libyen' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Litauen' },
  { code: 'LU', name: 'Luxemburg' },
  { code: 'MG', name: 'Madagaskar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Malediven' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshallinseln' },
  { code: 'MR', name: 'Mauretanien' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MX', name: 'Mexiko' },
  { code: 'FM', name: 'Mikronesien' },
  { code: 'MD', name: 'Moldawien' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolei' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MA', name: 'Marokko' },
  { code: 'MZ', name: 'Mosambik' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Niederlande' },
  { code: 'NZ', name: 'Neuseeland' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NO', name: 'Norwegen' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palau' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua-Neuguinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippinen' },
  { code: 'PL', name: 'Polen' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Katar' },
  { code: 'RO', name: 'Rumänien' },
  { code: 'RU', name: 'Russland' },
  { code: 'RW', name: 'Ruanda' },
  { code: 'KN', name: 'St. Kitts und Nevis' },
  { code: 'LC', name: 'St. Lucia' },
  { code: 'VC', name: 'St. Vincent und die Grenadinen' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'São Tomé und Príncipe' },
  { code: 'SA', name: 'Saudi-Arabien' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbien' },
  { code: 'SC', name: 'Seychellen' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapur' },
  { code: 'SK', name: 'Slowakei' },
  { code: 'SI', name: 'Slowenien' },
  { code: 'SB', name: 'Salomonen' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ZA', name: 'Südafrika' },
  { code: 'ES', name: 'Spanien' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'SE', name: 'Schweden' },
  { code: 'SY', name: 'Syrien' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TJ', name: 'Tadschikistan' },
  { code: 'TZ', name: 'Tansania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad und Tobago' },
  { code: 'TN', name: 'Tunesien' },
  { code: 'TR', name: 'Türkei' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'Vereinigte Arabische Emirate' },
  { code: 'GB', name: 'Vereinigtes Königreich' },
  { code: 'US', name: 'Vereinigte Staaten' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Usbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VA', name: 'Vatikanstadt' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Jemen' },
  { code: 'ZM', name: 'Sambia' },
  { code: 'ZW', name: 'Simbabwe' }
]